import { render, staticRenderFns } from "./WorkflowHeader.vue?vue&type=template&id=6954c470&"
import script from "./WorkflowHeader.vue?vue&type=script&lang=js&"
export * from "./WorkflowHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports